import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_contact_key_entity_link_RowClass} from '../../../dbschema/bl_crm_contact_key_entity_link.model';


export class ContactKeyEntityLinkContainerModel extends BaseContainerModel {
  bl_crm_contact_key_entity_link: bl_crm_contact_key_entity_link_RowClass = new bl_crm_contact_key_entity_link_RowClass();
}